import React from 'react';
import PropTypes from 'prop-types';
import './actionConfirmModal.scss';
import { ReactComponent as AlertIcon } from '../../../Assets/images/svg/alert_icon.svg';

const ActionConfirmModal = ({
  open,
  currentAction,
  title,
  message,
  confirmText,
  cancelText,
  className,
  onCancel,
  onConfirm,
}) => {
  if (!open) return null;

  return (
    <div className={`action-confirm-backdrop ${className}`.trim()} role="presentation">
      <div className="action-confirm-modal" role="dialog" aria-modal="true" aria-label={title}>
        <div className="action-confirm-header">
          <h3>{title}</h3>
        </div>
        <div className="action-confirm-body" >
          <div className= "action-confirm-divider" >
            <AlertIcon className="icon-image" />
            <div className="action-confirm-wrapper">
              <p className='action-confirm-message'>{message}</p>
              {currentAction === 'delete' && <p className="action-confirm-warning">This action cannot be undone.</p>}
            </div>
          </div>
        </div>

        <div className="action-confirm-footer">
          <button type="button" className="action-confirm-cancel" onClick={onCancel}>{cancelText}</button>
          <button type="button" className="action-confirm-submit" onClick={onConfirm}>{confirmText}</button>
        </div>
      </div>
    </div>
  );
};

ActionConfirmModal.propTypes = {
  open: PropTypes.bool,
  currentAction: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  className: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

ActionConfirmModal.defaultProps = {
  open: false,
  title: 'Confirm Action',
  message: 'Are you sure you want to continue?',
  confirmText: 'Yes',
  cancelText: 'No',
  className: '',
  onCancel: null,
  onConfirm: null,
};

export default ActionConfirmModal;
